import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
  TextInput,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";

const ReportCommissionStatement = ({}) => {
  const [period, setPeriod] = useState(moment().format("YYYYMM"));
  const [loading, setLoading] = useState(false);

  const [api] = useServerApi();
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.CommissionStatement.getReport({
        fromDate,
        toDate,
      });
      setLoading(false);

      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const { t } = useTranslation();

  return (
    <div>
      <Text size="xs">{t("Please enter the period of records")}</Text>
      <Group mt="xs">
        {/* <MonthSelect onChange={(p) => setPeriod(p)} /> */}
        {/* <TextInput onChange={(e) => setPeriod(e.target.value)} value={period} /> */}
        <DatePicker
          title={t("From Date")}
          size="xs"
          allowFreeInput
          placeholder="From"
          onChange={(d) => setFromDate(d)}
        />
        ~
        <DatePicker
          title={t("To Date")}
          size="xs"
          allowFreeInput
          placeholder="To"
          onChange={(d) => setToDate(d)}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
        disabled={!period}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportCommissionStatement;
